import { Component, EventEmitter, Injectable, Input, Output } from '@angular/core';
import { MessageService } from '@app/app/shared/services/message.service';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  templateUrl: './nav-filter-list.html',
  selector: 'nav-filter-list'
})
export class NavFilterListComponent {
  @Output() public clear: EventEmitter<any> = new EventEmitter<any>();

  @Input() filters = [];
  public form = new FormGroup({
    filter: new FormControl(''),
  });

  constructor(private messageService: MessageService) {
  }

  public resetFilter($event) {
    this.messageService.sendMessage($event.target.value);
    this.form.reset();

    this.clear.emit('reset');
  }

  public onChangeFilter($event: { event: boolean, value: any }): void {}

  public isFilterChecked(value: any): boolean {
    return false;
  }

  public onChange($event) {
    this.messageService.sendMessage($event.target.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/components/nav/filter-list/nav-filter-list.component.ts